var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dp-control-group',{class:{
    'dp-page-title-navigation': true,
    'dp-page-title-navigation--forward': _vm.forward,
  },attrs:{"right-aligned":_vm.forward}},[_c('dp-button',{staticClass:"dp-page-title-navigation__button",attrs:{"icon":_vm.icon,"type":"transparent"},on:{"click":_vm.navigate}}),_c('span',{staticClass:"dp-page-title-navigation__text"},[_vm._v(" "+_vm._s(_vm.title)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }